export default "__VITE_ASSET__9e4cbd9b__"